import { render, staticRenderFns } from "./ParentDetail.vue?vue&type=template&id=0cceffb5&scoped=true&"
import script from "./ParentDetail.vue?vue&type=script&lang=js&"
export * from "./ParentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ParentDetail.vue?vue&type=style&index=0&id=0cceffb5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cceffb5",
  null
  
)

export default component.exports